<template>
  <div>
    <b-row>
      <b-col xs="6" sm="4" md="4" lg="2" id="filter-controls">
        <div>
          <h3 style="display: inline">{{ this.$t('message.filters') }}</h3>
          <b-button
            size="md"
            variant="outline-primary"
            style="float: right"
            @click="clearAllFilters()"
          >
            {{ this.$t('message.clear_all') }}</b-button
          >
          <br /><br />
          <b-form-group
            id="showInactive-form-group"
            :label="this.$t('message.projects')"
          >
            <b-form-checkbox
              id="showInactive-form-checkbox"
              v-model="showInactive"
              value="true"
              unchecked-value="false"
            >
              {{ this.$t('message.show_inactive_projects') }}
            </b-form-checkbox>
          </b-form-group>
          <b-form-group
            id="showSuppressed-form-group"
            :label="this.$t('message.analysis_status')"
          >
            <b-form-checkbox
              id="showSuppressed-form-checkbox"
              v-model="showSuppressed"
              value="true"
              unchecked-value="false"
            >
              {{ this.$t('message.show_suppressed_findings') }}
            </b-form-checkbox>
          </b-form-group>
          <b-form-group
            id="severity-form-group"
            :label="this.$t('message.severity')"
          >
            <b-form-checkbox-group
              id="severity-form-checkbox-group"
              v-model="severitySelected"
              :options="severityOptions"
              stacked
            >
            </b-form-checkbox-group>
          </b-form-group>
          <b-form-group
            id="analysis-status-form-group"
            :label="this.$t('message.analysis_state')"
          >
            <b-form-checkbox-group
              id="analysis-status-form-checkbox-group"
              v-model="analysisStatusSelected"
              :options="analysisStatusOptions"
              stacked
            >
            </b-form-checkbox-group>
          </b-form-group>
          <b-form-group
            id="vendor-response-form-group"
            :label="this.$t('message.vendor_response')"
          >
            <b-form-checkbox-group
              id="vendor-response-form-checkbox-group"
              v-model="vendorResponseSelected"
              :options="vendorResponseOptions"
              stacked
            >
            </b-form-checkbox-group>
          </b-form-group>
          <b-form-group
            id="publish-date-form-group"
            :label="this.$t('message.published')"
          >
            <b-datepicker
              id="publish-date-datepicker-from"
              v-model="publishDateFrom"
              :max="publishDateTo"
              :placeholder="this.$t('message.from')"
            ></b-datepicker>
            <b-datepicker
              id="publish-date-datepicker-to"
              v-model="publishDateTo"
              :min="publishDateFrom"
              :placeholder="this.$t('message.to')"
            ></b-datepicker>
          </b-form-group>
          <b-form-group
            id="attributed-on-date-form-group"
            :label="this.$t('message.attributed_on')"
          >
            <b-datepicker
              id="attributed-on-datepicker-from"
              v-model="attributedOnDateFrom"
              :max="attributedOnDateTo"
              :placeholder="this.$t('message.from')"
            ></b-datepicker>
            <b-datepicker
              id="attributed-on-datepicker-to"
              v-model="attributedOnDateTo"
              :min="attributedOnDateFrom"
              :placeholder="this.$t('message.to')"
            ></b-datepicker>
          </b-form-group>
          <b-form-group
            id="text-search-form-group"
            :label="this.$t('message.text_search')"
          >
            <b-form-input
              id="text-search-form-input"
              v-model="textSearchInput"
              debounce="750"
              :placeholder="this.$t('message.search')"
            ></b-form-input>
            Search in:
            <b-form-checkbox-group
              id="text-search-form-checkbox-group"
              v-model="textSearchSelected"
              :options="textSearchOptions"
              stacked
            >
            </b-form-checkbox-group>
          </b-form-group>
          <b-form-group
            id="cvssv2-form-group"
            :label="this.$t('message.cvss_v2')"
          >
            <b-form-row>
              <b-col
                ><b-form-input
                  id="cvssv2-from-form-input"
                  v-model="cvssv2From"
                  type="number"
                  min="0"
                  :max="cvssv2UpperLimit()"
                  step="0.1"
                  debounce="750"
                  :state="cvssv2FromState()"
                  :placeholder="this.$t('message.from')"
                ></b-form-input
              ></b-col>
              <b-col
                ><b-form-input
                  id="cvssv2-to-form-input"
                  v-model="cvssv2To"
                  type="number"
                  :min="cvssv2LowerLimit()"
                  max="10"
                  step="0.1"
                  debounce="750"
                  :state="cvssv2ToState()"
                  :placeholder="this.$t('message.to')"
                ></b-form-input
              ></b-col>
            </b-form-row>
          </b-form-group>
          <b-form-group
            id="cvssv3-form-group"
            :label="this.$t('message.cvss_v3')"
          >
            <b-form-row>
              <b-col
                ><b-form-input
                  id="cvssv3-from-form-input"
                  v-model="cvssv3From"
                  type="number"
                  min="0"
                  :max="cvssv3UpperLimit()"
                  step="0.1"
                  debounce="750"
                  :state="cvssv3FromState()"
                  :placeholder="this.$t('message.from')"
                ></b-form-input
              ></b-col>
              <b-col
                ><b-form-input
                  id="cvssv3-to-form-input"
                  v-model="cvssv3To"
                  type="number"
                  :min="cvssv3LowerLimit()"
                  max="10"
                  step="0.1"
                  debounce="750"
                  :state="cvssv3ToState()"
                  :placeholder="this.$t('message.to')"
                ></b-form-input
              ></b-col>
            </b-form-row>
          </b-form-group>
        </div>
      </b-col>
      <b-col xs="6" sm="8" md="8" lg="10">
        <bootstrap-table
          ref="table"
          :columns="columns"
          :data="data"
          :options="options"
          @on-load-success="onLoadSuccess"
        >
        </bootstrap-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import common from '@/shared/common';
import xssFilters from 'xss-filters';
import $ from 'jquery';
import { loadUserPreferencesForBootstrapTable } from '@/shared/utils';

export default {
  computed: {
    watchers() {
      return [
        this.showInactive,
        this.showSuppressed,
        this.severitySelected,
        this.analysisStatusSelected,
        this.vendorResponseSelected,
        this.publishDateFrom,
        this.publishDateTo,
        this.attributedOnDateFrom,
        this.attributedOnDateTo,
      ];
    },
  },
  beforeMount() {
    this.initializeWatchers();
    this.textSearchSelected = this.textSearchOptions.map(
      (option) => option.value,
    );
  },
  methods: {
    initializeWatchers: function () {
      this.simpleWatcher = this.$watch('watchers', () => this.refreshTable());
      this.textSearchSelectedWatcher = this.$watch('textSearchSelected', () => {
        if (this.textSearchInput.trim().length !== 0) {
          this.refreshTable();
        }
      });
      this.textSearchInputWatcher = this.$watch(
        'textSearchInput',
        (newInput, oldInput) => {
          if (!(newInput.trim().length === 0 && oldInput.trim().length === 0)) {
            this.refreshTable();
          }
        },
      );
      this.cvssv2FromWatcher = this.$watch('cvssv2From', () => {
        if (this.cvssv2FromState() !== false) {
          this.refreshTable();
        }
      });
      this.cvssv2ToWatcher = this.$watch('cvssv2To', () => {
        if (this.cvssv2ToState() !== false) {
          this.refreshTable();
        }
      });
      this.cvssv3FromWatcher = this.$watch('cvssv3From', () => {
        if (this.cvssv3FromState() !== false) {
          this.refreshTable();
        }
      });
      this.cvssv3ToWatcher = this.$watch('cvssv3To', () => {
        if (this.cvssv3ToState() !== false) {
          this.refreshTable();
        }
      });
    },
    apiUrl: function () {
      let url = `${this.$api.BASE_URL}/${this.$api.URL_FINDING}`;
      url +=
        '?showInactive=' +
        (this.showInactive === 'true') +
        '&showSuppressed=' +
        (this.showSuppressed === 'true');
      if (this.severitySelected && this.severitySelected.length > 0) {
        url += '&severity=' + this.severitySelected;
      }
      if (
        this.analysisStatusSelected &&
        this.analysisStatusSelected.length > 0
      ) {
        url += '&analysisStatus=' + this.analysisStatusSelected;
      }
      if (
        this.vendorResponseSelected &&
        this.vendorResponseSelected.length > 0
      ) {
        url += '&vendorResponse=' + this.vendorResponseSelected;
      }
      if (this.publishDateFrom && this.publishDateFrom.length > 0) {
        url += '&publishDateFrom=' + this.publishDateFrom;
      }
      if (this.publishDateTo && this.publishDateTo.length > 0) {
        url += '&publishDateTo=' + this.publishDateTo;
      }
      if (this.attributedOnDateFrom && this.attributedOnDateFrom.length > 0) {
        url += '&attributedOnDateFrom=' + this.attributedOnDateFrom;
      }
      if (this.attributedOnDateTo && this.attributedOnDateTo.length > 0) {
        url += '&attributedOnDateTo=' + this.attributedOnDateTo;
      }
      if (this.textSearchInput && this.textSearchInput.trim().length > 0) {
        url +=
          '&textSearchField=' +
          this.textSearchSelected +
          '&textSearchInput=' +
          this.textSearchInput.trim();
      }
      if (this.cvssv2From && this.cvssv2From.trim().length > 0) {
        url += '&cvssv2From=' + this.cvssv2From;
      }
      if (this.cvssv2To && this.cvssv2To.trim().length > 0) {
        url += '&cvssv2To=' + this.cvssv2To;
      }
      if (this.cvssv3From && this.cvssv3From.trim().length > 0) {
        url += '&cvssv3From=' + this.cvssv3From;
      }
      if (this.cvssv3To && this.cvssv3To.trim().length > 0) {
        url += '&cvssv3To=' + this.cvssv3To;
      }
      return url;
    },
    clearAllFilters: function () {
      this.simpleWatcher();
      this.textSearchSelectedWatcher();
      this.textSearchInputWatcher();
      this.cvssv2FromWatcher();
      this.cvssv2ToWatcher();
      this.cvssv3FromWatcher();
      this.cvssv3ToWatcher();
      this.showInactive = false;
      this.showSuppressed = false;
      this.severitySelected = [];
      this.analysisStatusSelected = [];
      this.vendorResponseSelected = [];
      this.publishDateFrom = '';
      this.publishDateTo = '';
      this.attributedOnDateFrom = '';
      this.attributedOnDateTo = '';
      this.textSearchInput = '';
      this.textSearchSelected = this.textSearchOptions.map(
        (option) => option.value,
      );
      this.cvssv2From = '';
      this.cvssv2To = '';
      this.cvssv3From = '';
      this.cvssv3To = '';
      this.refreshTable();
      this.initializeWatchers();
    },
    refreshTable: function () {
      this.$refs.table.refresh({
        url: this.apiUrl(),
        silent: true,
        pageNumber: 1,
      });
    },
    initializeTooltips: function () {
      $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover',
      });
    },
    cvssv2UpperLimit: function () {
      return this.cvssv2To ? this.cvssv2To : 10;
    },
    cvssv2LowerLimit: function () {
      return this.cvssv2From ? this.cvssv2From : 0;
    },
    cvssv2FromState() {
      return this.cvssv2From
        ? !isNaN(this.cvssv2From) &&
            (!this.cvssv2To ||
              !isNaN(this.cvssv2To) ||
              this.cvssv2From <= this.cvssv2To) &&
            this.cvssv2From <= 10 &&
            this.cvssv2From >= 0
        : null;
    },
    cvssv2ToState() {
      return this.cvssv2To
        ? !isNaN(this.cvssv2To) &&
            (!this.cvssv2From ||
              !isNaN(this.cvssv2From) ||
              this.cvssv2To >= this.cvssv2From) &&
            this.cvssv2To <= 10 &&
            this.cvssv2To >= 0
        : null;
    },
    cvssv3UpperLimit: function () {
      return this.cvssv3To ? this.cvssv3To : 10;
    },
    cvssv3LowerLimit: function () {
      return this.cvssv3From ? this.cvssv3From : 0;
    },
    cvssv3FromState() {
      return this.cvssv3From
        ? !isNaN(this.cvssv3From) &&
            (!this.cvssv3To ||
              !isNaN(this.cvssv3To) ||
              this.cvssv3From <= this.cvssv3To) &&
            this.cvssv3From <= 10 &&
            this.cvssv3From >= 0
        : null;
    },
    cvssv3ToState() {
      return this.cvssv3To
        ? !isNaN(this.cvssv3To) &&
            (!this.cvssv3From ||
              !isNaN(this.cvssv3From) ||
              this.cvssv3To >= this.cvssv3From) &&
            this.cvssv3To <= 10 &&
            this.cvssv3To >= 0
        : null;
    },
    onLoadSuccess: function () {
      loadUserPreferencesForBootstrapTable(
        this,
        'VulnerabilityAuditByOccurrence',
        this.$refs.table.columns,
      );
    },
  },
  data() {
    return {
      simpleWatcher: null,
      textSearchSelectedWatcher: null,
      textSearchInputWatcher: null,
      cvssv2FromWatcher: null,
      cvssv2ToWatcher: null,
      cvssv3FromWatcher: null,
      cvssv3ToWatcher: null,
      showInactive: false,
      showSuppressed: false,
      severitySelected: [],
      severityOptions: [
        { text: 'Critical', value: 'critical' },
        { text: 'High', value: 'high' },
        { text: 'Medium', value: 'medium' },
        { text: 'Low', value: 'low' },
        { text: 'Unassigned', value: 'unassigned' },
      ],
      analysisStatusSelected: [],
      analysisStatusOptions: [
        { text: 'Not Set', value: 'NOT_SET' },
        { text: 'Exploitable', value: 'EXPLOITABLE' },
        { text: 'In Triage', value: 'IN_TRIAGE' },
        { text: 'Resolved', value: 'RESOLVED' },
        { text: 'False Positive', value: 'FALSE_POSITIVE' },
        { text: 'Not Affected', value: 'NOT_AFFECTED' },
      ],
      vendorResponseSelected: [],
      vendorResponseOptions: [
        { text: 'Not Set', value: 'NOT_SET' },
        { text: 'Can not fix', value: 'CAN_NOT_FIX' },
        { text: 'Will not fix', value: 'WILL_NOT_FIX' },
        { text: 'Update', value: 'UPDATE' },
        { text: 'Rollback', value: 'ROLLBACK' },
        { text: 'Workaround available', value: 'WORKAROUND_AVAILABLE' },
      ],
      publishDateFrom: '',
      publishDateTo: '',
      attributedOnDateFrom: '',
      attributedOnDateTo: '',
      textSearchInput: '',
      textSearchOptions: [
        { text: 'Vulnerability ID', value: 'vulnerability_id' },
        { text: 'Vulnerability Title', value: 'vulnerability_title' },
        { text: 'Component Name', value: 'component_name' },
        { text: 'Component Version', value: 'component_version' },
        { text: 'Project Name', value: 'project_name' },
      ],
      textSearchSelected: [],
      cvssv2From: '',
      cvssv2To: '',
      cvssv3From: '',
      cvssv3To: '',
      columns: [
        {
          title: this.$t('message.vulnerability'),
          field: 'vulnerability.vulnId',
          sortable: true,
          formatter(value, row, index) {
            let url = xssFilters.uriInUnQuotedAttr(
              '../vulnerabilities/' +
                row.vulnerability.source +
                '/' +
                encodeURIComponent(value),
            );
            return (
              common.formatSourceLabel(row.vulnerability.source) +
              ` <a href="${url}">${xssFilters.inHTMLData(value)}</a>`
            );
          },
        },
        {
          title: this.$t('message.title'),
          field: 'vulnerability.title',
          sortable: true,
        },
        {
          title: this.$t('message.severity'),
          field: 'vulnerability.severity',
          sortable: true,
          formatter(value, row, index) {
            if (typeof value !== 'undefined') {
              return common.formatSeverityLabel(value);
            }
          },
        },
        {
          title: this.$t('message.analyzer'),
          field: 'attribution.analyzerIdentity',
          sortable: true,
          formatter(value, row, index) {
            return common.formatAnalyzerLabel(
              row.attribution.analyzerIdentity,
              row.vulnerability.source,
              row.vulnerability.vulnId,
              row.attribution.alternateIdentifier,
              row.attribution.referenceUrl,
            );
          },
        },
        {
          title: this.$t('message.published'),
          field: 'vulnerability.published',
          sortable: true,
          formatter(value, row, index) {
            if (typeof value !== 'undefined') {
              return common.formatTimestamp(value);
            }
          },
        },
        {
          title: this.$t('message.cwe'),
          field: 'vulnerability.cwes',
          sortable: false,
          formatter(value, row, index) {
            if (typeof value !== 'undefined') {
              let s = '';
              for (let i = 0; i < value.length; i++) {
                let cwe = value[i];
                if (i > 0) {
                  s += ',&nbsp;&nbsp;&nbsp;';
                }
                s += `CWE-${cwe.cweId}`;
              }
              return s;
            }
          },
        },
        {
          title: this.$t('message.cvss_v2'),
          field: 'vulnerability.cvssV2BaseScore',
          sortable: true,
          formatter(value, row, index) {
            if (value && typeof value === 'number') {
              return value.toFixed(1);
            } else {
              return null;
            }
          },
        },
        {
          title: this.$t('message.cvss_v3'),
          field: 'vulnerability.cvssV3BaseScore',
          sortable: true,
          formatter(value, row, index) {
            if (value && typeof value === 'number') {
              return value.toFixed(1);
            } else {
              return null;
            }
          },
        },
        {
          title: this.$t('message.project_name'),
          field: 'component.projectName',
          sortable: true,
          formatter(value, row, index) {
            let url = xssFilters.uriInUnQuotedAttr(
              '../projects/' + row.component.project,
            );
            let name = common.concatenateComponentName(
              null,
              row.component.projectName,
              row.component.projectVersion,
            );
            return `<a href="${url}">${xssFilters.inHTMLData(name)}</a>`;
          },
        },
        {
          title: this.$t('message.component'),
          field: 'component.name',
          sortable: true,
          formatter: (value, row, index) => {
            let url = xssFilters.uriInUnQuotedAttr(
              '../../../components/' + row.component.uuid,
            );
            let dependencyGraphUrl = xssFilters.uriInUnQuotedAttr(
              '../../../projects/' +
                row.component.project +
                '/dependencyGraph/' +
                row.component.uuid,
            );
            return (
              `<a href="${dependencyGraphUrl}"<i class="fa fa-sitemap" aria-hidden="true" style="float:right; padding-top: 4px; cursor:pointer" data-toggle="tooltip" data-placement="bottom" title="Show in dependency graph"></i></a> ` +
              `<a href="${url}">${xssFilters.inHTMLData(value)}</a>`
            );
          },
        },
        {
          title: this.$t('message.version'),
          field: 'component.version',
          sortable: true,
          formatter(value, row, index) {
            if (
              Object.prototype.hasOwnProperty.call(
                row.component,
                'latestVersion',
              )
            ) {
              if (row.component.latestVersion !== row.component.version) {
                return (
                  '<span style="float:right" data-toggle="tooltip" data-placement="bottom" title="Risk: Outdated component. Current version is: ' +
                  xssFilters.inHTMLData(row.component.latestVersion) +
                  '"><i class="fa fa-exclamation-triangle status-warning" aria-hidden="true"></i></span> ' +
                  xssFilters.inHTMLData(row.component.version)
                );
              } else {
                return (
                  '<span style="float:right" data-toggle="tooltip" data-placement="bottom" title="Component version is the latest available from the configured repositories"><i class="fa fa-exclamation-triangle status-passed" aria-hidden="true"></i></span> ' +
                  xssFilters.inHTMLData(row.component.version)
                );
              }
            } else {
              return xssFilters.inHTMLData(common.valueWithDefault(value, ''));
            }
          },
        },
        {
          title: this.$t('message.analysis'),
          field: 'analysis.state',
          sortable: true,
          formatter: common.makeAnalysisStateLabelFormatter(this),
        },
        {
          title: this.$t('message.suppressed'),
          field: 'analysis.isSuppressed',
          sortable: true,
          class: 'tight',
          formatter(value, row, index) {
            return value === true ? '<i class="fa fa-check-square-o" />' : '';
          },
        },
        {
          title: this.$t('message.attributed_on'),
          field: 'attribution.attributedOn',
          sortable: true,
          formatter(value, row, index) {
            return xssFilters.inHTMLData(common.formatTimestamp(value));
          },
        },
      ],
      data: [],
      options: {
        onPostBody: this.initializeTooltips,
        search: false,
        showColumns: true,
        showRefresh: true,
        pagination: true,
        silentSort: false,
        sidePagination: 'server',
        queryParamsType: 'pageSize',
        pageList: '[10, 25, 50, 100]',
        pageSize:
          localStorage &&
          localStorage.getItem('VulnerabilityAuditByOccurrencePageSize') !==
            null
            ? Number(
                localStorage.getItem('VulnerabilityAuditByOccurrencePageSize'),
              )
            : 10,
        sortName:
          localStorage &&
          localStorage.getItem('VulnerabilityAuditByOccurrenceSortName') !==
            null
            ? localStorage.getItem('VulnerabilityAuditByOccurrenceSortName')
            : 'attribution.attributedOn',
        sortOrder:
          localStorage &&
          localStorage.getItem('VulnerabilityAuditByOccurrenceSortOrder') !==
            null
            ? localStorage.getItem('VulnerabilityAuditByOccurrenceSortOrder')
            : 'desc',
        icons: {
          refresh: 'fa-refresh',
        },
        toolbar: '#vulnerabilitiesToolbar',
        responseHandler: function (res, xhr) {
          res.total = xhr.getResponseHeader('X-Total-Count');
          return res;
        },
        url: this.apiUrl(),
        onPageChange: (number, size) => {
          if (localStorage) {
            localStorage.setItem(
              'VulnerabilityAuditByOccurrencePageSize',
              size.toString(),
            );
          }
        },
        onColumnSwitch: (field, checked) => {
          if (localStorage) {
            localStorage.setItem(
              'VulnerabilityAuditByOccurrenceShow' + common.capitalize(field),
              checked.toString(),
            );
          }
        },
        onSort: (name, order) => {
          if (localStorage) {
            localStorage.setItem(
              'VulnerabilityAuditByOccurrenceSortName',
              name,
            );
            localStorage.setItem(
              'VulnerabilityAuditByOccurrenceSortOrder',
              order,
            );
          }
        },
      },
    };
  },
};
</script>
